import React from "react";
// eslint-disable-next-line import/no-unresolved
import logo from "@src/assets/images/logo/uzeli-logo.svg";
import { COLORS } from "../../../utility/Utils";

const SpinnerComponent = () => {
  const skin = localStorage.getItem("skin");
  const isDarkMode = skin ? JSON.parse(skin) === "dark" : false;

  return (
    <div
      className="fallback-spinner vh-100"
      style={{
        background: isDarkMode ? COLORS.DARK_BG : undefined,
      }}
    >
      <img
        className="fallback-logo"
        src={logo}
        alt="logo"
        height="80px"
        width="80px"
      />
      <div className="loading">
        <div className="effect-1 effects" />
        <div className="effect-2 effects" />
        <div className="effect-3 effects" />
      </div>
    </div>
  );
};

export default SpinnerComponent;
